// extracted by mini-css-extract-plugin
export var Faqs = "FaqSection-module--Faqs--6aa1f";
export var accordionHeaderRootCustom = "FaqSection-module--accordionHeaderRootCustom--1bbfb";
export var accordionTitleCustom = "FaqSection-module--accordionTitleCustom--1a73d";
export var colDetails = "FaqSection-module--colDetails--6112f";
export var iconContainerCustom = "FaqSection-module--iconContainerCustom--4c1cf";